import { Menu } from 'components/Menu';
import * as React from 'react';

import { ICONS } from './Icon';
import { ButtonTheme } from './Button';

type Options<ValueT extends string> = {
  id: ValueT;
  name: string;
};

type Props<ValueT extends string> = {
  value?: ValueT;
  options: Options<ValueT>[];
  onChange: (value: ValueT) => void;
  disabled?: boolean;
};

export const SortMenu = <ValueT extends string>({
  onChange,
  options,
  value,
  disabled,
}: Props<ValueT>): React.ReactElement => {
  const onMenuItemPress = React.useCallback(
    (sort: ValueT) => () => {
      onChange(sort);
    },
    [onChange],
  );

  const currentOption = options.find(({ id }) => id === value);

  return (
    <Menu
      buttonConfig={{
        chipLike: true,
        text: currentOption?.name || 'Unknown',
        disabled,
        iconRight: ICONS.CaretDownSolid,
        iconRightSize: 12,
        textSize: 'small',
        buttonTheme: ButtonTheme.themeless,
      }}
      options={options.map((option) => ({
        leftIcon:
          option.id === value ? ICONS.CircleDotSolid : ICONS.CircleLight,
        key: option.id.toString(),
        onPress: onMenuItemPress(option.id),
        text: `Sort ${option.name}`,
      }))}
    />
  );
};
